import { render, staticRenderFns } from "./CourseCategoryDrag.vue?vue&type=template&id=43c1f931&scoped=true&"
import script from "./CourseCategoryDrag.vue?vue&type=script&lang=js&"
export * from "./CourseCategoryDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c1f931",
  null
  
)

export default component.exports